import { WistiaPlayer as Player } from '@wistia/wistia-player-react';
import PropTypes from 'prop-types';

export default function WistiaPlayer ({ value }) {
  return value
    ? <Player mediaId={value} />
    : null;
}

WistiaPlayer.propTypes = {
  value: PropTypes.string,
};
